// ie
// import 'core-js';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// animate.css
import animated from 'animate.css';

// custom
import apiPlugin from './api';
import util from './utils';

// 全局组件npm i vue-awesome-swiper@3.1.3
import '@/components/index';

// 全局样式
import './styles/index.scss';

// 全局filter
import '@/filters/index';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './element-variables.scss';
import VueAreaLinkage from 'vue-area-linkage';
import 'vue-area-linkage/dist/index.css'; // v2 or higher
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import VueLazyload from 'vue-lazyload';
import * as echarts from 'echarts';
import newapi from './api/modules/api.js';
import {
	initData
} from './utils/initData';
Vue.use(animated);
Vue.use(ElementUI);
Vue.use(VueAreaLinkage);
Vue.use(VueAwesomeSwiper);
Vue.use(VueLazyload, {
	loading: require('./image/AI-banner.png'),
	attempt: 2
});
Vue.use(apiPlugin);
Vue.config.productionTip = false;
// Vue.prototype.$api = api;
Vue.prototype.$util = util;
Vue.prototype.$echarts = echarts;
Vue.prototype.$newapi = newapi;
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');

initData();
router.afterEach((to, from, next) => {
	const body = document.querySelector('body');
	body.scrollTo(0, 0);
	window.scrollTo(0, 0);
});
